module.exports = __webpack_public_path__ + "img/16_120.f29a3205.png";